var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.78,
    height: 68.808,
    viewBox: "0 0 49.78 68.808",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#040e26;}.b{fill:none;stroke:#040e26;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-920 -4945.096)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M28.8-29.7,15.7.5h-1.62L.99-29.7H6.345L14.9-9.045,23.445-29.7Z",
    transform: "translate(919.01 4984.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.825.5a12.775,12.775,0,0,1-6.57-1.71A12.52,12.52,0,0,1,1.62-5.94L4.995-8.505A13.12,13.12,0,0,0,8.347-5.062,7.636,7.636,0,0,0,12.78-3.78,5.8,5.8,0,0,0,16.493-4.9,3.651,3.651,0,0,0,17.91-7.92,3.141,3.141,0,0,0,16.9-10.4a14.276,14.276,0,0,0-3.352-1.98L10.26-13.9A16.836,16.836,0,0,1,5.175-17.28,6.666,6.666,0,0,1,3.33-22.14a7.321,7.321,0,0,1,1.26-4.23,8.184,8.184,0,0,1,3.4-2.835,11.053,11.053,0,0,1,4.7-.99,11.087,11.087,0,0,1,5.67,1.463,10.594,10.594,0,0,1,3.915,3.847l-3.33,2.565A8.381,8.381,0,0,0,16.177-25a6.852,6.852,0,0,0-3.487-.922,5.394,5.394,0,0,0-3.2.922A3.075,3.075,0,0,0,8.19-22.32a3.1,3.1,0,0,0,.5,1.8,4,4,0,0,0,1.3,1.192q.81.473,2.34,1.238l3.33,1.53a16.579,16.579,0,0,1,5.355,3.6A6.961,6.961,0,0,1,22.77-8.1a8.065,8.065,0,0,1-1.282,4.523A8.352,8.352,0,0,1,17.932-.562,11.964,11.964,0,0,1,12.825.5Z",
    transform: "translate(947.01 5002.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M30,0,0,68",
    transform: "translate(929.5 4945.5)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVs);
export default __webpack_public_path__ + "static/media/vs.df6261fd45ee8e72c4745658f83080d4.svg";
export { ForwardRef as ReactComponent };